<script lang="ts" setup>
import type { ComplexClassName } from '@docue/docue-ui-v2/types/common'

withDefaults(defineProps<{
  sidebarPlacement?: 'left' | 'right'
  sidebarWrapperClasses?: ComplexClassName
}>(), {
  sidebarPlacement: 'left',
})
</script>

<template>
  <div
    :class="{ 'lg:flex-row-reverse': sidebarPlacement === 'right' }"
    class="flex flex-col gap-0 lg:flex-row lg:items-start lg:gap-10"
  >
    <div
      :class="sidebarWrapperClasses"
      class="flex flex-col items-start gap-10"
    >
      <slot name="sidebar" />
    </div>
    <div class="flex w-full grow flex-col justify-start gap-6">
      <slot />
    </div>
  </div>
</template>
